import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "agent-card";

const keys = addTranslations(RESOURCE_NAME, {
    title_cdp_expert: {
        en: "Expert AI CDP coach",
        fr: "Coach IA - expert CDP",
    },
    title_evs_expert: {
        en: "Expert AI Ecovadis coach",
        fr: "Coach IA - expert Ecovadis",
    },
    title_doc_reviewer: {
        en: "Review your policy",
        fr: "Vérifier ma politique",
    },
    title_questionnaire_uploader: {
        en: "Import a questionnaire",
        fr: "Importer un questionnaire",
    },
    title_quick_answer_suggestor: {
        en: "Answer customer questions",
        fr: "Répondre aux questions clients",
    },
    subtitle_cdp_expert: {
        en: "to answer all your questions",
        fr: "pour poser toutes vos questions",
    },
    subtitle_evs_expert: {
        en: "to answer all your questions",
        fr: "pour poser toutes vos questions",
    },
    subtitle_doc_reviewer: {
        en: "to get actionable feedback",
        fr: "pour avoir des conseils concrets",
    },
    subtitle_questionnaire_uploader: {
        en: "and generate all the answers",
        fr: "et générer toutes les réponses",
    },
    subtitle_quick_answer_suggestor: {
        en: "using your Knowledge Base",
        fr: "grâce à la bibliothèque IA",
    },
});

export function useAgentCardTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
